import EditServerNameModal from '@/features/Servers/containers/EditServerNameModal'
import ConfirmServersWithoutPatchModal from '@/features/Clusters/containers/ConfirmServersWithoutPatchModal'
import RebootNodeModal from '@/features/Servers/containers/RebootNodeModal'
import ApplyClusterConfigModal from '@/features/Clusters/containers/ApplyClusterConfigModal'
import DeleteSubnetModal from '@/features/Network/containers/DeleteSubnetModal'
import ConfirmClusterConfigChangeModal from '@/features/Clusters/containers/ConfirmClusterConfigChangeModal'

export const modalToComponent = {
  editServerName: EditServerNameModal,
  confirmServersWithoutPatch: ConfirmServersWithoutPatchModal,
  rebootNode: RebootNodeModal,
  applyClusterConfig: ApplyClusterConfigModal,
  deleteSubnet: DeleteSubnetModal,
  confirmClusterConfigChange: ConfirmClusterConfigChangeModal,
}

export type AvailableModals = keyof typeof modalToComponent
